import { Icon, IconifyIcon } from '@iconify/react';
import { useRef, useState } from 'react';
// import homeFill from '@iconify/icons-eva/home-fill';
// import personFill from '@iconify/icons-eva/person-fill';
// import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Avatar, Box, Button, Divider, MenuItem, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
// components
import { MIconButton } from '../../components/@material-extend';
import MenuPopover from '../../components/MenuPopover';

import homeFill from '@iconify/icons-eva/home-fill';
import preval from 'preval.macro';
import { keycloakService } from '../../../keycloak';
// ----------------------------------------------------------------------

type MenuOption = {
  label: string;
  icon: IconifyIcon;
  linkTo: string;
};
const MENU_OPTIONS: MenuOption[] = [
  { label: 'Home', icon: homeFill, linkTo: process.env.PUBLIC_URL }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar
          alt="My Avatar"
          src={`${process.env.PUBLIC_URL}/static/mock-images/avatars/avatar_default.jpg`}
        />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 240 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {keycloakService.getUsername()}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {keycloakService.getUserEmail()}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            Build: {preval`module.exports = new Date().toLocaleString('en-US');`}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="warning"
            variant="contained"
            onClick={() => keycloakService.doLogout()}
          >
            Sair
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
